/**
 * Tabs component
 * @returns <Tabs />
 */

import { useState } from "react";
import BoxWithBorder from "./BoxWithBorder";
import InputContainer from "./InputContainer";
import Select from "./Select";
import Button from "./Button";
import InputRange from "./InputRange";
import { useCreditSimulationMutation } from "../redux/apiSlice";
import LoaderMini from "./LoaderMini";

const Tabs = (props) => {
    const { model, cash, clickHandler, item, financeOn } = props;

    const [activeTab, setActiveTab] = useState("option-1");
    const [fees, setFees] = useState("24");
    const [step, setStep] = useState ("step-1")
    const [sliderValue, setSliderValue] = useState(31);
    const [finance, setFinance] = useState(null);
    const [error, setError] = useState(null);
    const [creditSimulation] = useCreditSimulationMutation();


    const options = [
        {
            dataLabel: "option-1",
            dataValue: "cash",
            label: "contado",
        },
        {
            dataLabel: "option-2",
            dataValue: "financing",
            label: "financiación MAF",
        }
    ]

    const cuotas = [
        {
            'label': '25 cuotas',
            'dataValue': '24'
        },
        {
            'label': '37 cuotas',
            'dataValue': '36'
        }
    ]

    const data = {
        "downpaymentPercentage": parseInt(sliderValue),
        "smartBuy": false,
        "numberFees": parseInt(fees),
        "vehicleAmount": parseInt(item.price.replace(/\./g, ''), 10),
        "optionCode": item.option_code,
        "dealershipId": "5000149"
    }

    const onClickTabHandler = (e) => {
        setActiveTab(e.target.dataset.label);
        clickHandler(e.target.dataset.value);
    }

    const feesHandler = (e) => {
        setFees(e)
    }

    const stepsHandler = (e) => {
        setStep(e)
        if (e == "step-2") {
            setFinance(null)
            creditSimulation(data)
            .then((response) => {
                if (response.error) {
                    throw new Error(response.error);
                }
                setFinance(response.data)
            })
            .catch((error) => {
                console.error("Error in credit simulation:", error);
                setError("Hubo un problema al simular el crédito.");
            });
        }
    }

    const handleSliderChange = (newValue) => {
        setSliderValue(newValue);
    };

    const reset = () => {
        setStep("step-1");
        setFinance(null);
        setError(null);
    }

    return (
        <div className="tabs">
        {
            financeOn ?
            <div className="tabs__controls --box">
                {options.map((option, i) => {
                    return (
                        <button className={`tabs__control ${activeTab === option.dataLabel ? "--active" : ""}`} data-label={option.dataLabel} data-value={option.dataValue} key={i} onClick={onClickTabHandler}>{option.label}</button>
                    )
                })}
            </div> : null
        }

            <div className={`tabs__content ${activeTab === "option-1" ? "--active" : ""}`}>
                <BoxWithBorder type="price" label={model} currency={cash.currency} price={cash.price} />
            </div>

            <div className={`tabs__content finance step-1 ${activeTab === "option-2" ? "--active" : ""} ${step === "step-1" ? "--step-active" : "--hidden"}`}>
                <p>1. Elige el Porcentaje de Pie</p>
                <InputRange onSliderChange={handleSliderChange}></InputRange>
                <p>2. Selecciona en cuantas cuotas deseas comprar tu vehículo.</p>
                <InputContainer>
                    <Select
                        type={"select"}
                        name={"cuotas"}
                        label={"Cuotas"}
                        placeholder={
                            "25 cuotas"
                        }
                        dropdownItems={cuotas}
                        selectChangeHandler={
                            feesHandler
                        }
                    />
                </InputContainer>

                <Button tag="button" btnStyle="outline" text="Simular financiación" onClick={() => stepsHandler("step-2")} />
            </div>
            <div className={`tabs__content finance step-2 ${activeTab === "option-2" ? "--active" : ""} ${step === "step-2" ? "--step-active" : "--hidden"}`}>
                <div className="extra-info">
                    {
                        !finance && !error ? 
                            <LoaderMini />
                        : error ? 
                            <div>
                                <p className="error-message">{error}</p>
                                <Button tag="button" btnStyle="outline" text="Reintentar" onClick={() => reset()} />
                            </div>
                            
                        :
                            <div className="extra-info__container">
                                <p className="extra-info__label">Valor del Pie <span className="extra-info__price">({data.downpaymentPercentage}%) ${finance.downPayment.toLocaleString('es-ES')}</span></p>
                                <p className="extra-info__label">{data.numberFees} cuotas mensuales de <span className="extra-info__price">${finance.paymentAmountTotal.toLocaleString('es-ES')}</span></p>
                                <p className="extra-info__label">1 cuota Final de Plan Renueve <span className="extra-info__price">${finance.vfg.toLocaleString('es-ES')}</span></p>
                                <p className="extra-info__label">Costo Total del Crédito <span className="extra-info__price red">${(finance.totalCost + finance.vfg).toLocaleString('es-ES')} | CAE: {finance.cae}%</span></p>
                            </div>
                    }
                    <div className="extra-info__text-container">
                        <p className="extra-info__text">Los valores y conceptos indicados en esta simulación son referenciales, no vinculantes y no conllevan la aprobación y otorgamiento del crédito, el cual es gestionado y otorgado por MAF Chile. El Valor Cuota incluye gastos operacionales e impuestos al crédito. Las cuales se encuentran calculadas con vencimiento en 30 días.<br /><br />El monto de la cuota para financiamiento automotriz es meramente referencial y no vinculante, los montos en pesos chilenos informados y demás condiciones del crédito están sujetas a variación en función del monto y plazo en que se tome el crédito. No considera meses de gracia o pago diferido. Los valores informados incluyen impuesto al crédito, gastos o cargos propios del crédito, no incluye cargos por productos o servicios voluntariamente contratados.</p>
                    </div>
                </div> 
                { finance ? <Button tag="button" btnStyle="outline" text="Editar" onClick={() => stepsHandler("step-1")} /> : null}
                
            </div>
        </div>
    )
}

export default Tabs